import styled from 'styled-components'

export const BgImage = styled.div<{ imageUrl: string }>`
  background-image: url('${({ imageUrl }) => imageUrl}');
  background-position: center;
  background-size: cover;
  height: 480px;
  width: 100%;
  border-radius: 20px;

  @media (max-width: 768px) {
    height: 240px;
  }
`
